// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--v8Wme","logo":"_7a3fb80146--logo--TN8gi","description":"_7a3fb80146--description--XHYiD"};